import React, { useState } from 'react';
import VehicleCard from './VehicleCard';
import vehicles from './vehicles';
import './Fleet.css';

const FILTERS = [
  { key: 'all', label: 'All' },
  { key: 'available', label: 'Available Now' },
  { key: 'coming-soon', label: 'Coming Soon' },
];

function Fleet() {
  const [filter, setFilter] = useState('all');
  const visibleVehicles =
    filter === 'all' ? vehicles : vehicles.filter((vehicle) => vehicle.status === filter);

  return (
    <section className="fleet">
      <h1 className="fleet__title">Our Fleet</h1>
      <div className="fleet__filters" role="group" aria-label="Filter by availability">
        {FILTERS.map(({ key, label }) => (
          <button
            key={key}
            type="button"
            className={`fleet__filter${filter === key ? ' fleet__filter--active' : ''}`}
            aria-pressed={filter === key}
            onClick={() => setFilter(key)}
          >
            {label}
          </button>
        ))}
      </div>
      <div className="fleet__grid">
        {visibleVehicles.map((vehicle) => (
          <VehicleCard
            key={vehicle.slug}
            name={vehicle.name}
            year={vehicle.year}
            imageSrc={vehicle.images[0]}
            imageAlt={vehicle.imageAlt}
            status={vehicle.status}
            price={vehicle.price || 'Contact for pricing'}
            to={`/fleet/${vehicle.slug}`}
          />
        ))}
      </div>
    </section>
  );
}

export default Fleet;
